import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import s from './Loader.module.scss';

class Loader extends React.Component {
    static propTypes = {
        size: PropTypes.number.isRequired,
    };

    static defaultProps = {
        size: 34,
    };

    render() {
        return (
            <div className={cx(s.root, this.props.className)}>
                {/* <div className={s.logo}><img src="/images/shark-chat.svg" alt="" className="img-responsive" /></div> */}
                <div><i className="la la-circle-notch la-spin" style={{ fontSize: this.props.size }} /></div>
            </div>
        );
    }
}

export default Loader;
